import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, variant = "default", ...props }, ref) => {
  const variants = {
    default: "border-input bg-background focus-visible:ring-ring",
    luxury: "border-silver/30 bg-muted focus-visible:ring-silver focus-visible:border-silver/50",
  }
  
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-lg border px-4 py-3 text-base shadow-sm transition-all duration-300 placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 md:text-sm resize-none",
        variants[variant] || variants.default,
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
